













































































































import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store";

import { Machine } from "@/model/data/Machine";
import { familyLabelToIndex } from "@/model/data/logAnalysis/Reject";

export default Vue.extend({
    props: {
        machine: Object as () => Machine,
        processedCashList: Array,
        nDays: Number,
        dateListString: Array,
        loading: Boolean,
        rejectList: Array,
        rejectCauseMap: Object,
        rejectsFamilyMap: Map,
        familyLabelMap: Map,
        startDate: Date,
        seriesPCTrendList: Array,
    },
    data() {
        return {
            seriesList: [],
            rejectTypeList: [],
            seriesTypeList: [],
            rejectTableData: [],
            rejectTableHeader: [
                { text: this.$t("logAnalysis.rejectFamily"), value: "family", sortable: false },
                { text: this.$t("logAnalysis.rejectCause"), value: "cause", sortable: false },
                { text: this.$t("logAnalysis.rejectCount"), value: "number" },
                { text: this.$t("logAnalysis.rejectPercentage"), value: "percentage" },
            ],
            rejectLegendHeader: [
                { text: this.$t("logAnalysis.rejectCause"), value: "cause", sortable: false },
                { text: this.$t("logAnalysis.rejectDescription"), value: "description", sortable: false },
            ],
            rejectLegendData: [],
            totalRowRejectDataTable: {
                number: 0,
                percentage: 0,
            },
        };
    },
    computed: {
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        chartRejectTrend() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "area",
                        stacked: true,
                        zoom: {
                            enabled: false,
                        },
                        animations: {
                            enabled: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "straight",
                    },
                    grid: {
                        row: {
                            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                            opacity: 0.5,
                        },
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateListString,
                    },
                    yaxis: {
                        labels: {
                            formatter: (value) => {
                                if (value != null) {
                                    return (value % 1 == 0 ? value.toFixed(0) : value.toFixed(2)) + "%";
                                }
                                return null;
                            },
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => (value != null ? value.toFixed(2) + "%" : null),
                        },
                    },
                },
                series: this.seriesList,
            };
        },
        chartRejectType() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "bar",
                        animations: {
                            enabled: false,
                        },
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: true,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        categories: this.rejectTypeList,
                        labels: {
                            formatter: (value) => value.toFixed(2) + "%",
                        },
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => value.toFixed(2) + "%",
                        },
                    },
                },
                series: this.seriesTypeList,
            };
        },
    },
    watch: {
        rejectList: {
            handler(value) {
                this.seriesList = [];
                this.rejectTypeList = [];
                this.seriesTypeList = [];
                this.rejectTableData = [];
                this.rejectLegendData = [];
                this.totalRowRejectDataTable = {
                    number: 0,
                    percentage: 0,
                };
                if (value && value.length) {
                    if (this.rejectCauseMap != null && this.rejectCauseMap != undefined)
                        Object.keys(this.rejectCauseMap)
                            .sort((a, b) => a.localeCompare(b))
                            .forEach((key) => {
                                this.rejectLegendData.push({ cause: key, description: this.rejectCauseMap[key] });
                            });
                    let seriesTable = new Map<string, Array<number>>();

                    let causes = [...new Set<string>(this.rejectList.map((reject) => reject.cause))];
                    let rejectCausebyFamily = new Map<string, Array<string>>();
                    let fillerList = new Array(this.nDays).fill(null);
                    this.processedCashList.forEach((pc) => {
                        let utcDate = Date.UTC(pc.dateTime.getFullYear(), pc.dateTime.getMonth(), pc.dateTime.getDate(), 0, 0, 0);
                        let dayIndex = Math.floor((utcDate - this.startDate.getTime()) / (1000 * 3600 * 24));
                        fillerList[dayIndex] = 0;
                    });
                    let keyCause = null;
                    causes.forEach((cause) => {
                        seriesTable.set(cause, Array.from(fillerList));
                        if (this.rejectsFamilyMap.get(cause) == undefined) keyCause = "default";
                        else keyCause = cause;
                        if (rejectCausebyFamily.has(this.rejectsFamilyMap.get(keyCause))) rejectCausebyFamily.get(this.rejectsFamilyMap.get(keyCause)).push(cause);
                        else rejectCausebyFamily.set(this.rejectsFamilyMap.get(keyCause), [cause]);
                    });

                    let totalReject = new Array(this.nDays).fill(0);
                    this.rejectList.forEach((reject) => {
                        let utcDate = Date.UTC(reject.dateTime.getFullYear(), reject.dateTime.getMonth(), reject.dateTime.getDate(), 0, 0, 0);
                        let dayIndex = Math.floor((utcDate - this.startDate.getTime()) / (1000 * 3600 * 24));
                        totalReject[dayIndex] += reject.count;
                    });
                    let rejectTypeMap = new Map<string, number>();
                    this.rejectList.forEach((reject) => {
                        let utcDate = Date.UTC(reject.dateTime.getFullYear(), reject.dateTime.getMonth(), reject.dateTime.getDate(), 0, 0, 0);
                        let dayIndex = Math.floor((utcDate - this.startDate.getTime()) / (1000 * 3600 * 24));
                        seriesTable.get(reject.cause)[dayIndex] = (reject.count * 100) / (this.seriesPCTrendList[0].data[dayIndex] + totalReject[dayIndex]);
                        if (rejectTypeMap.has(reject.cause)) rejectTypeMap.set(reject.cause, rejectTypeMap.get(reject.cause) + reject.count);
                        else rejectTypeMap.set(reject.cause, reject.count);
                    });
                    let totalDepositedAndReject =
                        this.processedCashList.map((pc) => pc.deposited).reduce((accumulator, curr) => accumulator + curr) +
                        totalReject.reduce((accumulator, curr) => accumulator + curr);
                    rejectTypeMap = new Map([...rejectTypeMap.entries()].sort((a, b) => String(a[0]).localeCompare(b[0])));
                    this.rejectTypeList = Array.from(rejectTypeMap.keys());
                    this.seriesTypeList = [{ name: "Reject", data: Array.from(rejectTypeMap.values()).map((r) => (r * 100) / totalDepositedAndReject) }];
                    seriesTable.forEach((value, key) => {
                        this.seriesList.push({ name: key, data: value });
                    });
                    rejectCausebyFamily = new Map([...rejectCausebyFamily.entries()].sort((a, b) => familyLabelToIndex.get(a[0]) - familyLabelToIndex.get(b[0])));
                    rejectCausebyFamily.forEach((value, key) => {
                        let number = value.map((c) => rejectTypeMap.get(c)).reduce((acc, curr) => acc + curr);
                        let percentage = (number * 100) / totalDepositedAndReject;
                        this.totalRowRejectDataTable.number += number;
                        this.totalRowRejectDataTable.percentage += percentage;
                        this.rejectTableData.push({ family: this.familyLabelMap.get(key), cause: value.join(","), number: number, percentage: percentage.toFixed(2) + "%" });
                    });
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        setRowStyle() {
            return "style-1";
        },
    },
});
